// Used when creating the markup in layouts
import React from 'react';
import PropTypes from 'prop-types';
import Loader from '../loader';
import { useAnalytics } from 'use-analytics';
import { useAppState } from '../app-context/src';

const Tab = (props) => {
  const { children, route } = props;
  const analytics = useAnalytics();
  const appState = useAppState();

  React.useEffect(() => {
    analytics.track('b view tab', {
      category: 'browse',
      bookshelf: appState.shelfCode,
      label: route,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <React.Suspense fallback={<Loader />}>{children}</React.Suspense>;
};

Tab.propTypes = {
  children: PropTypes.node.isRequired,
};

export default React.memo(Tab);
